import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'

function Section2({data}) {
    return (
        <div id="section2" className="section2 mt-scroll pt-5 pb-4 scroll-div" style={{ backgroundColor: '#f0e7da' }}>
            {/* Gotham Font Implementation */}
            <style>
                {`
                /* Gotham Font Faces - Replace URLs with your actual font file paths */
                @font-face {
                    font-family: 'Gotham';
                    src: url('/fonts/Gotham-Book.woff2') format('woff2'),
                         url('/fonts/Gotham-Book.woff') format('woff');
                    font-weight: 400;
                    font-style: normal;
                    font-display: swap;
                }
                
                @font-face {
                    font-family: 'Gotham';
                    src: url('/fonts/Gotham-Medium.woff2') format('woff2'),
                         url('/fonts/Gotham-Medium.woff') format('woff');
                    font-weight: 500;
                    font-style: normal;
                    font-display: swap;
                }
                
                @font-face {
                    font-family: 'Gotham';
                    src: url('/fonts/Gotham-Bold.woff2') format('woff2'),
                         url('/fonts/Gotham-Bold.woff') format('woff');
                    font-weight: 700;
                    font-style: normal;
                    font-display: swap;
                }
                
                /* Font Styling */
                .section-paragraph {
                    font-family: 'Gotham', 'Helvetica Neue', Helvetica, Arial, sans-serif;
                    font-weight: 400; /* Change to 500 for Medium weight */
                    line-height: 1.6;
                    letter-spacing: 0.2px;
                    color: #333333;
                }
                `}
            </style>
            
            <Container fluid className="me-0">
                <Row>
                    <Col md={6} className="m-auto section2-1" data-aos="fade-up" data-aos-duration="2500">
                        <Image src="https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/AboutMila/about mila_1.webp" />
                        <p className="section-paragraph">Following the success of Smoky Beach JBR, Mila by Smoky brings a laid-back, seaside shisha experience to Palm Jumeirah West Beach, located at the Radisson Hotel. Inspired by the meaning of “Mila” - graciousness and serenity, the venue is designed for pure relaxation.
 
With an ethereal white and blue palette, earthy textures, and a minimalist, zen-like feel, Mila offers stunning views of the Arabian Gulf and an effortlessly relaxed atmosphere, perfect for easy afternoons and chilled evenings by the beach.
 
Shisha is at the heart of the experience, featuring a curated selection of classic favorites, signature house blends, and fresh fruity fusions; smooth, flavorful, and crafted to be enjoyed at your own pace.</p>
                    </Col>
                    <Col md={6} className="p-0">
                        <Image src={"https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/AboutMila/about mila.webp"} className="side-image" data-aos="fade-up" data-aos-duration="2500" />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Section2;